import React, { useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SearchSection from "./components/SearchSection";
// import MapSection from "./components/MapSection";
import FeaturedSprings from "./components/FeaturedSprings";
import NewsSection from "./components/NewsSection";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import LivecamModal from "./components/LivecamModal";

function App() {
  const [isLivecamOpen, setIsLivecamOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Header 
        onOpenLivecam={() => setIsLivecamOpen(true)} 
      />
      <main>
        <Hero />
        <SearchSection />
        {/* <MapSection /> */}
        <FeaturedSprings />
        <NewsSection />
        <Newsletter />
      </main>
      <Footer 
        onOpenLivecam={() => setIsLivecamOpen(true)} 
      />
      <LivecamModal 
        isOpen={isLivecamOpen} 
        onClose={() => setIsLivecamOpen(false)} 
      />
    </div>
  );
}

export default App;
